import Env from '../env';
import { getCurrentLocation } from './custom_domain';

export const displayableAppVersion = () => {
  const displayableJobID = (Env.BUILD_JOB_ID || 'unknown').replace(/^0+/, '');
  return displayableJobID;
};

/**
 * A trimmed version of the user agent string,
 * with information that helps determine the OS, browser version,
 * and/or Smorg Companion app version.
 */
export const displayableUserAgent = () => {
  const userAgent = navigator.userAgent || '';
  const marker = ' (KHTML, like Gecko) ';
  const index = navigator.userAgent.indexOf(marker);
  const abridgedUserAgent =
    index !== -1 ? userAgent.slice(index + marker.length).trim() : userAgent;
  // If running inside the native app (SmorgCompanion/xxx), hide the Smorg brand
  const maskedAbridgedUserAgent = abridgedUserAgent.replace(
    /SmorgCompanion/g,
    'Native app',
  );
  return maskedAbridgedUserAgent;
};

export const displayableAppDomain = () => {
  const currentLocation = getCurrentLocation();
  if (currentLocation.endsWith('.smorg.io')) {
    // Hide the Smorg brand
    return '';
  }
  return currentLocation;
};
